
import Vue from 'vue';
import { fuzzyFilter } from '@/utils/fuzzySearch';
import EmptyState from '@/components/states/EmptyState.vue';
import RunnitCarousel from '@/views/Runnits/RunnitCarousel.vue';
import OfferingCardWithLabels from '@/components/OfferingCardWithLabels.vue';
import { mapState } from 'vuex';
import { deriveKitTags, initialKitTag } from '@run-diffusion/shared';

export default Vue.extend({
	name: 'KitToolsFiltersAndSelection',
	mixins: [],
	components: {
		EmptyState,
		RunnitCarousel,
		OfferingCardWithLabels,
	},
	props: {
		options: { type: Array, default: () => [] },
		containerStyles: { type: [Object, String], default: null },
		hideAllToolsButton: { type: Boolean, default: false },
		currentRunnit: { type: Object, default: null },
	},
	data () {
		return {
			selectedFilterKey: 'Featured',
			searchText: '',
		};
	},
	computed: {
		...mapState([
			'publicRunnitNodeDefs',
			'companyRunnitNodeDefs',
		]),
		allRunnitNodeDefs () {
			return [
				...this.publicRunnitNodeDefs,
				...this.companyRunnitNodeDefs,
			];
		},
		filteredOptions () {
			const optionsByCategory = this.options.filter((option) => !!(option.tags && option.tags[this.selectedFilterKey]));

			if (!this.searchText) {
				return optionsByCategory;
			}

			return fuzzyFilter(
				optionsByCategory,
				this.searchText,
				[
					{ name: 'text', weight: 0.7 },
					{ name: 'description', weight: 0.3 },
				]
			);
		},
		// Featured first, the rest alphabetically, Other last. The ordering
		// lives in the shared Kit Resolver so web and the future /api/v2/kits
		// cannot disagree about the tab row.
		filterTags () {
			return deriveKitTags(this.options as any[]);
		},
		filterItems () {
			return this.filterTags;
		},
	},
	mounted () {
		this.setInitialFilter();
	},
	methods: {
		isOptionSelected (option: any): boolean {
			// Check if this option is the currently selected one in the runnit
			if (!this.currentRunnit || !this.currentRunnit.singleToolNodeDefId) {
				return false;
			}

			// Compare the runnit's singleToolNodeDefId with the option's value (which is the nodeDefId)
			return this.currentRunnit.singleToolNodeDefId === option.value;
		},
		getRunnitNodeDefForOption (option: any) {
			// Find the corresponding RunnitNodeDef from the database
			const runnitNodeDef = this.allRunnitNodeDefs.find(nodeDef => nodeDef.id === option.value);
			return runnitNodeDef;
		},
		setInitialFilter () {
			// initialKitTag holds the rule: land on the tab containing the
			// already-selected tool, else Featured, else the first tab.
			const tag = initialKitTag(
				{ tags: this.filterTags, tools: this.options as any[] } as any,
				this.currentRunnit?.singleToolNodeDefId || null,
			);
			if (tag) this.selectedFilterKey = tag;
		},
	},
});
